var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import styled from 'styled-components';
import { SpinnerContainer } from '@usecapsule/react-common';
import { CpslSpinner } from '@usecapsule/react-components';
export const PasswordCreationStep = () => {
    const passwordAuthURLForCreate = useModalStore(state => state.passwordUrlForCreate);
    const currentStep = useModalStore(state => state.step);
    const capsule = useCapsuleStore(state => state.capsule);
    const [shortLoginLink, setShortLoginLink] = useState();
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        if (currentStep !== ModalStep.BIOMETRIC_LOGIN) {
            setShortLoginLink(null);
        }
        if (!passwordAuthURLForCreate) {
            return;
        }
        function shortenUrl() {
            return __awaiter(this, void 0, void 0, function* () {
                const shortUrl = yield capsule.shortenLoginLink(passwordAuthURLForCreate);
                setShortLoginLink(shortUrl);
            });
        }
        shortenUrl();
    }, [passwordAuthURLForCreate]);
    return (_jsxs(OuterContainer, { children: [_jsx(Container, { isReady: isReady, children: _jsx("iframe", { src: shortLoginLink, onLoad: () => {
                        setIsReady(true);
                    } }) }), !isReady && (_jsx(SpinnerContainer, { style: { width: '100%', height: '100%', flex: 1 }, children: _jsx(CpslSpinner, { size: 100 }) }))] }));
};
const OuterContainer = styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;
const Container = styled.div `
  height: 100%;
  width: 100%;
  display: ${({ isReady }) => (isReady ? 'block' : 'none')};

  & > iframe {
    height: 360px;
    width: 100%;
    border: none;
  }
`;
